if (!customElements.get('testing-cartridge-picker')) {
  class TestingCartridgePicker extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener('click', this.handleClick, { signal });
      window.addEventListener('euroguard:testing-cartridge-change', this.handleChange, { signal });
      this.sync(window.EuroguardTestingStore?.cartridge);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-cartridge]');
      if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;

      window.EuroguardTestingStore?.selectCartridge(button.dataset.cartridge);
      this.sync(button.dataset.cartridge);
    };

    handleChange = (event) => {
      this.sync(event.detail?.cartridge);
    };

    sync(cartridgeId) {
      if (!cartridgeId) return;

      this.querySelectorAll('[data-cartridge]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.cartridge === cartridgeId));
      });
    }
  }

  customElements.define('testing-cartridge-picker', TestingCartridgePicker);
}

